/**
 * SoftphoneDevTools Constants
 */

/**
 * Maximum number of debug records to persist.
 */
export const MAX_DEBUG_HISTORY_CALLS = 50;

/**
 * LocalForage key for persisting debug history
 */
export const SOFTPHONE_DEBUG_HISTORY_KEY = 'softphone_devtools_debug_history';

/** Human label for a scenario key, so a badge reads like prose rather than a key. */
export const SCENARIO_LABELS: Record<string, string> = {
  'blind-transfer': 'blind transfer',
  'voicemail-transfer': 'voicemail transfer',
  'warm-transfer': 'warm transfer',
  conference: 'conference leg',
  'conference-room': 'conference room',
};